import React from 'react';
import { Flex } from 'antd';
import AgentCardSkeletonItem from './AgentCardSkeletonItem';

const AgentCardSkeleton = () => {
    return (
        <Flex justify="center" gap={8} wrap>
            {[...Array(3)].map((_, index) => (
                <AgentCardSkeletonItem key={index} />
            ))}
        </Flex>
    );
};

export default AgentCardSkeleton;